module.exports = __webpack_public_path__ + "static/media/23_CALCINHA_LATERAL_DRAPEADA_ESTAMPADA_02.37fd8b63.jpg";